import React from 'react';
import { Login } from '../login';

export const PublicRouter = () => {
  return <Login />;
};
